import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../src/environments/env';

@Injectable({
  providedIn: 'root'
})
export class SppdashboardService {
 private apiUrl = environment.BASE_URL+`/ptp/`;
  public header = { headers: { 'Access-Control-Allow-Origin': '*' } }

  constructor(private http: HttpClient) { }

  public logout(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + 'security/ssoLogout',this.header);
  }

  public marketplacelink(country: string, lang: string): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + 'api/public/marketplace/country/'+country+'/lang/'+lang+'/marketplace-link',this.header);
  }

  public getInstructors(baseCountry?: string, countryFilter = '', timeZoneFilter = '', page = 0, size = 20): Observable<any[]> {
    let params = new HttpParams();

    if (countryFilter) {
      params = params.set('countryList', countryFilter);
    }

    //if (timeZoneFilter) {
    params = params.set('userTimeZone', timeZoneFilter);
    //}

    if (baseCountry) {
      params = params.set('baseCountry', baseCountry);
    }

    params = params.set('page', page.toString());
    params = params.set('size', size.toString());

    return this.http.get<any[]>(this.apiUrl + 'api/spp/training-calendars', {
      ...this.header,
      params
    });
  }

  public userexist(email:any):Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + 'api/spp/mct/email?email='+email,this.header);
  }

  // public newUserSubmit(payload:any,email:any, userSelectedFlow:any):Observable<any[]> {
  //   let url = (userSelectedFlow === 'ILTFlow') ? 'api/spp/mct/ILT/User?email=' :  'api/spp/mct/MctUser?email=';
  //   return this.http.put<any[]>(this.apiUrl + url + email,payload,this.header);
  // }

  public userSubmit(payload:any,email:any):Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + 'api/spp/mct/ILT/User?email='+email,payload,this.header);
  }

  public submitISCPForm(payload:any,email:any):Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + 'api/spp/mct/MctUser?email='+email,payload,this.header);
  }

  public submitILT(payload:any,email:any):Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + 'api/spp/mct/ILT/User?email='+email,payload,this.header);
  }

  public userReinstatementSubmit(payload:any):Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + 'api/spp/mct/Expired',payload,this.header);
  }

  public testOutUser(payload:any):Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + `api/spp/mct/TestOut/User?email=${payload.email}`,payload,this.header);
  }

 public renewalSubmit(payload: any): Observable<any> {
  //  return of({
  //    "data": {
  //      "email": "testmctuser47@outlook.com",
  //      "firstname": "John",
  //      "lastname": "Doe",
  //      "selfAttest": true,
  //      "mctAgreement": true,
  //      "transScriptUrl": "https://example.com/transcript.pdf",
  //      "status": "RENEWAL_REJECT",
  //      "mctRenewalSubmissionDate": "2026-08-21T17:58:45.5202534+05:30",
  //      "mctRenewalApprovedDate": "2026-08-21T17:58:45.5202534+05:30",
  //      "reasons": [
  //        {
  //          "reasonText": "Minimum valid class count requirement not met. Your count: 40"
  //        },
  //        {
  //          "reasonText": "Minimum total evaluation count requirement not met. Your count: 20"
  //        },
  //        {
  //          "reasonText": "Minimum average 5-point score requirement not met. Your average: 4.20"
  //        }
  //      ],
  //      "language": "Algerian Arabic",
  //      "country": "Afghanistan"
  //    },

  //    "success": true,
  //    "message": ["Renewal status updated to RENEWAL_REJECT"],
  //    "errors": []
  //  });    

   return this.http.put<any[]>(this.apiUrl + 'api/spp/mtm/renewal', payload, this.header);
  }

  public expiredSubmit(firstname:any,lastname:any,mmt_id:any):Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + 'api/spp/mct/Expired?firstname='+firstname +'&lastname='+lastname+'&mmt_id='+mmt_id,this.header);
  }
  

  public termsprivacy(payload:any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + 'security/updateTermsPrivacy',payload,this.header);
  }

  //  public payLink(userid:any): Observable<any[]> {
  //   return this.http.get<any[]>(this.apiUrl + 'api/spp/countries/user/' + userid + '/link',this.header);
  // }

   public payLink(countryCode: string, status: string): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/countries/user/getPayLinkByCountryCode?countryCode=${countryCode}&status=${status}`,this.header);
  }
  


  public admin(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + 'security/adminuser?entryPoint=http://localhost:4200/#/admin/dashboard',this.header);
  }

  public login(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + 'security/sppuser?entryPoint=http://localhost:4200/',this.header);
  }

  public getUser(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + 'api/spp/dashboard/userDetails', this.header);
  }

  public getMetrics(week:any,month:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + 'api/spp/dashboard/metrics?week='+week+'&?month='+month,this.header);
  }

  public getAnnouncements(title:any,asc:any,page:any,size:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/dashboard/announcement?title=`+title+`&asc=`+asc+`&page=`+ page + `&size=`+ size,this.header);
  }

  public getEvents(page:any,size:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/dashboard/training-event?page=`+ page + `&size=`+ size,this.header);
  }

  public getLeads(page:any,size:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/dashboard/learning-leads?page=`+ page + `&size=`+ size,this.header);
  }

  public updateLeadstatus(id:any,status:any): Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + `api/spp/dashboard/learning-leads/`+id+'/status?statusId='+status,this.header);
  }

  public downloadCSV(id:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/dashboard/learningLeads/download-csv?uniqueIds=`+ id ,this.header);
  }

  public getPartners(name:any,offerings:any,location:any,page:any,size:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/partner?name=`+name +'&'+ offerings +`&location=`+location + `&page=`+ page + `&size=`+ size,this.header);
  }

  public viewPartner(id:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/partner/`+ id,this.header);
  }
  
  public getOfferings(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/partner/offerings`,this.header);
  }

  public getLocations(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/partner/locations`,this.header);
  }

  public getAssets(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/assets/category`,this.header);
  }

  public viewAssets(id:any,name:any,filtername:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/assets?category=`+id+`&name=`+name+`&filterName=`+filtername,this.header);
  }

  public fetchFilters(id:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/assets/category/`+id+`/filterNames`,this.header);
  }

  public viewLead(id:any): Observable<any[]>{
    return this.http.put<any[]>(this.apiUrl + `api/spp/dashboard/learning-leads/viewed/`+id,this.header)
  }

  public viewAnnouncement(id:any): Observable<any[]>{
    return this.http.put<any[]>(this.apiUrl + `api/spp/dashboard/announcement/Viewed/`+id,this.header)
  }

  public viewAdmin(): Observable<any[]>{
    return this.http.put<any[]>(this.apiUrl + `api/spp/dashboard/userDetails/user/partner/remove`,this.header)
  }

  public getIscpProviderList(page: any, size: any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/iscp-provider?page=`+ page + `&size=` + size,this.header);
  }

  public getLanguageList(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/languages`,this.header);
  }

  public getCountriesForUserCountryTier(baseCountry: string): Observable<any[]> {
      return this.http.get<any[]>(this.apiUrl + `api/spp/countries/getCountriesForUserCountryTier?baseCountry=` + baseCountry,this.header);
  }

  public getCountryList(): Observable<any[]> {
      return this.http.get<any[]>(this.apiUrl + `api/spp/countries`,this.header);
  }

  public getTimeZoneList(countryNames: string[], baseCountry: string): Observable<any[]> {
      return this.http.post<any[]>(this.apiUrl + `api/spp/countries/user/timeZones/filter`, {countryNames:countryNames, baseCountry: baseCountry}, this.header);
  }

  public getTimeZonesByCountryName(countryName: string): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/countries/user/getTimeZonesByCountryName?countryName=` + countryName, this.header);
  }

  public getRegion(id:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/countries/${id}`,this.header);
  }

   public uploadIscpProviderList(payload:any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + `api/spp/iscp-provider/iscp-training-reference/upload`,payload,this.header);
  }

  public addtimeline(payload:any): Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + `api/spp/timeline/1`,payload,this.header);
  }

   public gettimeline(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/timeline`,this.header);
  }

  public runExpired(): Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + `api/spp/mct/run`,this.header);
  }

  public getStatus(userid:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/dashboard/${userid}/status`,this.header);
  }

   public runLogs(page:any,size:any,filterString: String): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/status-logs?page=`+ page + `&size=` + size + filterString,this.header);
  }

   public getEmail(id:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/email/settings/`+id,this.header);
  }

  public updateEmail(id:any,payload:any): Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + `api/admin/email/settings/`+id,payload,this.header);
  }

  public updateTemplate(id:any,payload:any): Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + `api/admin/email/template/`+id,payload,this.header);
  }

   public getTemplate(id:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/email/template/`+id,this.header);
  }

   public getTemplateUser(id:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/mct/email/template/`+id,this.header);
  }

  public getSettingsUser(id:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/mct/email/settings/`+id,this.header);
  }

  public getReports(page: any, size: any,status:any,from:any,to:any,email:string): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/user/report?email=`+email+`&page=`+ page + `&size=` + size + `&status=`+ status + `&fromDate=`+from+`&toDate=`+to,this.header);
  }

  public downloadReports(status:any,from:any,to:any): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/admin/user/report/download?status=`+ status + `&fromDate=`+from+`&toDate=`+to,this.header);
  }

   public updateProfile(payload:any,userId:any): Observable<any[]>{
    return this.http.put<any[]>(this.apiUrl + `api/spp/mct/update/`+userId,payload,this.header)
  }

   public getPayment(email:any): Observable<any[]>{
    return this.http.get<any[]>(this.apiUrl + `api/admin/mct/paymentDetails/byEmail?email=`+email,this.header)
  }

  public getMCTMetrics(from:any,to:any): Observable<any[]>{
    return this.http.get<any[]>(this.apiUrl + `api/admin/user/report/count?fromDate=`+from+`&toDate=`+to,this.header)
  }

  public downloadCertificate(): Observable<Blob>{
    const httpOptions = {
      ...this.header,
      responseType: 'blob' as 'json'
    };
    return this.http.get<Blob>(this.apiUrl + `api/spp/cert/cert-download`, httpOptions)
  }  

  public getRejectionReason(): Observable<any[]>{
    return this.http.get<any[]>(this.apiUrl + `api/admin/rejectionRemarks`,this.header)
  }

  public sumbmitAluminiRequest(payload:any, id: any): Observable<any[]>{
    return this.http.put<any[]>(this.apiUrl + `api/spp/alumni/submit/${id}`,payload,this.header)
  }

  private isValidEmail(email: string): boolean {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
}

  getStatusForThreeYear = (email:any): Observable<any[]> => {
     if (!this.isValidEmail(email)) {
    //return throwError(() => new Error('Invalid email format'));
  }
  const params = new HttpParams().set('email', email);
  return this.http.get<any[]>(
    `${this.apiUrl}api/spp/mct-users-history/check-status`,
    { headers: this.header.headers, params }
  );
    //return this.http.get<any[]>(this.apiUrl + `api/spp/mct-users-history/check-status?email=`+email,this.header);
  }

  public generate(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/spp/cert/generateTokenizedUrl`,this.header);
  }

  public open(token:any,ip:any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + `api/public/cert/mct`,null,{ headers: {'Content-Type': 'application/json','mct_user_token': token,'mct_user_ip': ip}});
  }

    public enrollUserForILTSession(sessionId: string, userid:any): Observable<any[]> {
      return this.http.post<any[]>(this.apiUrl + `api/spp/training-calendars/${sessionId}/enrollments/intent?userId=`+userid,this.header);
  }

  // public validateCaptcha(token: string): Observable<any[]> {
  //   return of({ success: true, score: 0.7, action: 'submit', hostname: 'localhost' } as any);
  // }

  // TODO:- remove the above mock and uncomment the below real API call once backend is ready to accept captcha token for validation
   public validateCaptcha(recaptchaToken: string): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + `api/public/recaptcha/verify`, { recaptchaToken }, this.header);
  }

  public getDowntimeStatus(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + `api/public/banner-message`,this.header);
  }

  // public checkForRenewalEligibility(): Observable<any[]> {
  //   return this.http.get<any[]>(this.apiUrl + `api/spp/mtm/renewal-eligibility`,this.header);
  // }


}
